// extracted by mini-css-extract-plugin
export default {"logoutButton":"logoutButton_logoutButton__5WdN5","logoutIcon":"logoutButton_logoutIcon__52gU8"};